import { IonText } from '@ionic/react';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';

import Nbsp from '@components/Nbsp';
import useGetMyTimeWithTimezoneAbbreviation from '@hooks/useGetMyTimeWithTimezoneAbbreviation';

type Props = {
  endTime: Date;
  startTime: Date;
};

const DateAndTimeRange = ({ endTime, startTime }: Props) => {
  const getMyTimeWithTimezoneAbbreviation = useGetMyTimeWithTimezoneAbbreviation();

  return (
    <IonText data-test="date-and-time">
      <FormattedDate day="numeric" month="short" value={startTime} weekday="short" year="numeric" />
      <Nbsp />
      <FormattedTime value={startTime} />
      <Nbsp />
      <FormattedMessage id="dictionary.to" />
      <Nbsp />
      {getMyTimeWithTimezoneAbbreviation(endTime)}
    </IonText>
  );
};

export default DateAndTimeRange;
